// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  numero_WhatsApp: "+393357141371",
  numero_telefono: "tel:+390962964868",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "in comode <strong>2 rate</strong>",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://192.168.1.53/',
  urlMaterialeDidattico: 'http://192.168.1.53/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://192.168.1.53/assets/media/corso/',
  urlImageCorsoHD: 'http://192.168.1.53/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://192.168.1.53/assets/media/corso/video/',
  web_api_url_base: 'http://192.168.1.53/api/',

  urlStampa: 'http://192.168.1.53/stampe/',

  urlAttestati: 'http://192.168.1.53/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://192.168.1.53/pages/certificate/',
  urlImagePartners: 'http://192.168.1.53/assets/media/partners/',
  urlImageMedia: 'http://localhost/assets/media/',

  */

  urlWeb: 'https://iusekr.discentya.it/',
  urlMaterialeDidattico: 'https://iusekr.discentya.it/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://iusekr.discentya.it/assets/media/corso/',
  urlImageCorsoHD: 'https://iusekr.discentya.it/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://iusekr.discentya.it/assets/media/corso/video/',
  web_api_url_base: 'https://iusekr.discentya.it/api/',

  urlStampa: 'https://iusekr.discentya.it/stampe/',

  urlAttestati: 'https://iusekr.discentya.it/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://iusekr.discentya.it/pages/certificate/',
  urlImagePartners: 'https://iusekr.discentya.it/assets/media/partners/',

  urlImageMedia: 'https://iusekr.discentya.it/assets/media/',

};

